import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';

import MLRewriteEffectiveDatePage from './pages/MLRewriteEffectiveDatePage/MLRewriteEffectiveDatePage';
import MLRewriteCoveragesPage from './pages/MLRewriteCoveragesPage/MLRewriteCoveragesPage';
import MLRewriteVerbalAuthorizationPage from './pages/MLRewriteVerbalAuthorizationPage/MLRewriteVerbalAuthorizationPage';
import MLRewriteRequiredSignaturesPage from './pages/MLRewriteRequiredSignaturesPage/MLRewriteRequiredSignaturesPage';
import MLRewriteAvailableDocumentsPage from './pages/MLRewriteAvailableDocumentsPage/MLRewriteAvailableDocumentsPage';
import MLRewriteConfirmationPage from './pages/MLRewriteConfirmationPage/MLRewriteConfirmationPage';

setComponentMapOverrides(
    {
        MLRewriteEffectiveDatePage: { component: 'MLRewriteEffectiveDatePage' },
        MLRewriteCoveragesPage: { component: 'MLRewriteCoveragesPage' },
        MLRewriteVerbalAuthorizationPage: { component: 'MLRewriteVerbalAuthorizationPage' },
        MLRewriteRequiredSignaturesPage: { component: 'MLRewriteRequiredSignaturesPage' },
        MLRewriteAvailableDocumentsPage: { component: 'MLRewriteAvailableDocumentsPage' },
        MLRewriteConfirmationPage: { component: 'MLRewriteConfirmationPage' }
    },
    {
        MLRewriteEffectiveDatePage,
        MLRewriteCoveragesPage,
        MLRewriteVerbalAuthorizationPage,
        MLRewriteRequiredSignaturesPage,
        MLRewriteAvailableDocumentsPage,
        MLRewriteConfirmationPage
    }
);


export { default as Rewrite } from './model/Rewrite';
export { default as RewriteWizard }  from './RewriteWizard';
export { default as MLRewriteContactUsPage } from './pages/MLRewriteContactUsPage/MLRewriteContactUsPage';
